import React, { useState, useRef, useEffect } from "react";
import { FaUserNinja } from "react-icons/fa";
import { useAdmin } from "../contexts/AdminContext";
import API_URL from "../config";
import "../styles/AddTrainer.css";

const CustomDropdown = ({ options, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div
      className="custom-dropdown"
      ref={dropdownRef}
      style={{
        width: 350,
        margin: 0,
      }}
    >
      <button
        type="button"
        className="dropdown-toggle"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: "100%",
          padding: "10px",
          border: "1px solid gray",
          borderRadius: 5,
        }}
      >
        {value || "Select"}
      </button>
      {isOpen && (
        <ul className="dropdown-options">
          {options.map((option) => (
            <li key={option} onClick={() => handleOptionClick(option)}>
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const AddTrainer = () => {
  const { admin } = useAdmin();
  const [trainerData, setTrainerData] = useState({
    trainerId: "",
    name: "",
    username: "",
    gender: "",
    age: "",
    address: "",
    phone: "",
    branch: admin?.branch,
    permissions: {
      overview: false,
      userManagement: false,
      membershipManagement: false,
      dietPlanManagement: false,
      exerciseManagement: false,
      gstInvoiceAndAgreement: false,
      trainerManagement: false,
      bookingManagement: false,
      postManagement: false,
      notificationManagement: false,
      termsandconditions: false,
      settingsAndAdminControls: false,
    },
  });

  const [loading, setLoading] = useState(false);
  const [checkedItems, setCheckedItems] = useState(Array(12).fill(false));

  const handleChange = (e) => {
    setTrainerData({ ...trainerData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (index) => {
    const newCheckedItems = [...checkedItems];
    newCheckedItems[index] = !newCheckedItems[index];
    setCheckedItems(newCheckedItems);

    const permissionKeys = Object.keys(trainerData.permissions);
    const updatedPermissions = { ...trainerData.permissions };
    updatedPermissions[permissionKeys[index]] = newCheckedItems[index];

    setTrainerData({ ...trainerData, permissions: updatedPermissions });
  };

  const permissionTitles = [
    "overview",
    "userManagement",
    "membershipManagement",
    "dietPlanManagement",
    "exerciseManagement",
    "gstInvoiceAndAgreement",
    "trainerManagement",
    "bookingManagement",
    "postManagement",
    "notificationManagement",
    "termsandconditions",
    "settingsAndAdminControls",
  ];

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/trainer/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(trainerData),
      });

      const result = await response.json();
      if (response.ok) {
        alert("Trainer added successfully!");
        setTrainerData({
          trainerId: "",
          name: "",
          username: "",
          gender: "",
          age: "",
          address: "",
          phone: "",
          branch: admin?.branch,
          permissions: permissionTitles.reduce((acc, key) => {
            acc[key] = false;
            return acc;
          }, {}),
        });

        setCheckedItems(Array(permissionTitles.length).fill(false));
      } else {
        console.error(result.message || "Error adding trainer.");
      }
    } catch (error) {
      console.error("Network error. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="addUserManagementContainer">
      <div className="addUserManagementHeader">
        <div className="addUserHeaderLeft">
          <FaUserNinja size={30} color="#ff0000" style={{ marginRight: 10 }} />
          <h2>Add Trainer</h2>
        </div>
      </div>
      <div className="addUserProfileContainer">
        <h3>Trainer Profile</h3>
        <div className="addUserProfileMain">
          <p>Basic Information :</p>
          <div className="addUserProfileInputMain">
            <div className="addUserProfileInput">
              <label>Trainer ID</label>
              <input
                type="text"
                name="trainerId"
                value={trainerData.trainerId}
                onChange={handleChange}
              />
            </div>
            <div className="addUserProfileInput">
              <label>Username</label>
              <input
                type="text"
                name="username"
                value={trainerData.username}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="addUserProfileInputMain">
            <div className="addUserProfileInput">
              <label>Trainer Name</label>
              <input
                type="text"
                name="name"
                value={trainerData.name}
                onChange={handleChange}
              />
            </div>
            <div className="addUserProfileInput">
              <label>Phone no</label>
              <input
                type="text"
                name="phone"
                value={trainerData.phone}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="addUserProfileInputMain">
            <div className="addUserProfileInput">
              <label htmlFor="gender">Gender</label>
              <CustomDropdown
                options={["Male", "Female", "Other"]}
                value={trainerData.gender}
                onChange={(selectedValue) =>
                  setTrainerData({ ...trainerData, gender: selectedValue })
                }
              />
            </div>

            <div className="addUserProfileInput">
              <label>Age</label>
              <input
                type="text"
                name="age"
                value={trainerData.age}
                onChange={handleChange}
                style={{ width: "180px" }}
              />
            </div>
          </div>
          <div className="addUserProfileInputMain">
            <div className="addUserProfileInput">
              <label>Address</label>
              <input
                type="text"
                name="address"
                value={trainerData.address}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>

      <h3 style={{ marginTop: 20 }}>Permissions: </h3>
      <div className="slider-container">
        <div className="slider">
          {permissionTitles.map((title, index) => (
            <div key={index} className="slider-item">
              <p>{title.charAt(0).toUpperCase() + title.slice(1)}</p>
              <label>
                <input
                  type="checkbox"
                  checked={checkedItems[index]}
                  onChange={() => handleCheckboxChange(index)}
                  style={{
                    width: "25px",
                    height: "25px",
                    cursor: "pointer",
                  }}
                />
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="addUserBottomAggreementAndSaveButtonContainer">
        <button onClick={handleSubmit} disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default AddTrainer;
